import ComponentFactory from '@heal/factories/component-factory.js';

import Form from '@heal/components/form.js';
import Partial from '@heal/components/partial.js';
import ToastObserver from '@heal/components/toast-observer.js';

ComponentFactory.register({
  ToastObserver,
  Form,
  Partial,

  Checkable: () => import('@heal/components/checkable.js'),
  Accordion: () => import('@heal/components/accordion.js'),
  // Filedrop: () => import('@heal/components/filedrop.js'),
  // Sortable: () => import('@heal/components/sortable.js'),
  AsyncSelect: () => import('@heal/components/async-select.js'),
  // Comment: () => import('@heal/components/comment.js'),

  VideoPlayer: () => import('./components/video-player.js'),
  VideoView: () => import('./components/video-view.js'),
  VideoFavorite: () => import('./components/video-favorite.js'),
  Signup: () => import('./components/signup.js'),
  Plan: () => import('./components/plan.js'),
});



// import AccordionComponent from '@heal/components/accordion-component.js';
// import AsyncSelectComponent from '@heal/components/async-select-component.js';
// import CheckableComponent from '@heal/components/checkable-component.js';
// // import CommentComponent from '@heal/components/comment-component.js';
// // import FiledropComponent from '@heal/components/filedrop-component.js';
// import FormComponent from '@heal/components/form-component.js';
// import PartialComponent from '@heal/components/partial-component.js';
// // import SortableComponent from '@heal/components/sortable-component.js';
// import ToastObserverComponent from '@heal/components/toast-observer-component.js';

// ComponentFactory.register({
//   AccordionComponent,
//   AsyncSelectComponent,
//   CheckableComponent,
//   // CommentComponent,
//   // FiledropComponent,
//   FormComponent,
//   PartialComponent,
//   // SortableComponent,
//   ToastObserverComponent,
// });

// import VideoPlayerComponent from './components/video-player-component.js';
// import VideoViewComponent from './components/video-view-component.js';
// import VideoFavoriteComponent from './components/video-favorite-component.js';
// import SignupComponent from './components/signup-component.js';

// ComponentFactory.register({
//   VideoPlayerComponent,
//   VideoViewComponent,
//   VideoFavoriteComponent,
//   SignupComponent,
// });

ComponentFactory.initialize();


// import ControllerFactory from '@heal/factories/controller-factory.js';

// import VideoPlayer from './controllers/video-player-controller.js';
// import VideoView from './controllers/video-view-controller.js';
// import VideoFavorite from './controllers/video-favorite-controller.js';

// ControllerFactory.initialize({ VideoPlayer, VideoView, VideoFavorite });

import Splide from 'splide';

const splideVideoCards = document.querySelectorAll('.splide-video-cards');
splideVideoCards.forEach(elm => {
    new Splide(elm, {
      type: 'slide',
      rewind: true,
      gap: '1.5rem',
      fixedWidth: '360px',
      perMove: 3,
      fixedHeight: '100%',
      pagination: false,
      breakpoints: {
          768: {
            perMove: 2,
          },
          425: {
            fixedWidth: '280px',
            perMove: 1,
          },
      }
    }).mount();
});

const splideTopBanners = document.querySelectorAll('.splide-top-banners');
splideTopBanners.forEach(elm => {
    const splide = new Splide(elm, {
      type: 'fade',
      cover: true,
      // autoplay: true,
      interval: 5000,
      rewind: true,
      // fixedHeight: '80vh',
      fixedWidth: '100%',
      pagination: false,
      // classes: {
      //   arrows: 'splide__arrows your-class-arrows',
      //   arrow : 'splide__arrow your-class-arrow',
      //   prev  : 'splide__arrow--prev your-class-prev',
      //   next  : 'splide__arrow--next your-class-next',
      // },
      // pauseOnHover: true,
      // type: 'slide',
      // rewind: true,
      // gap: 0,
      // fixedWidth: '360px',
      // perMove: 3,
      // fixedHeight: '360px',
      // breakpoints: {
      //     768: {
      //       perMove: 2,
      //     },
      //     425: {
      //       fixedWidth: '280px',
      //       perMove: 1,
      //     },
      // }
    }).mount();
  // splide.on( 'click', function (event) {
  //   console.log(event);
  //   // 何かの処理
  //   const url = event.container.dataset.url;
  //   if (url) {
  //     setTimeout(() => location.href = url);
  //     // return false;
  //   }
  // });
} );
// document.querySelectorAll('.splide__slide__container').forEach(elm => {
//   elm.addEventListener('click', event => {
//     const url = event.currentTarget.closest('.splide__slide__container').dataset.url;
//     if (url) {
//       location.href = url;
//       // return false;
//     }
//     event.preventDefault();
//   })
// });

const videoPlayOnHover = document.querySelectorAll('video.play-on-hover');
videoPlayOnHover.forEach(video => {
    video.addEventListener('mouseenter', () => video.play());
    video.addEventListener('mouseleave', () => {
        video.pause();
        video.currentTime = 0;
    });
});